import { graphql } from '~/lib/graphql'

export const ReviewsNodesFragment = graphql(/* GraphQL */ `
  fragment ReviewsNodes on Review2 {
    __typename
    ... on Review {
      handleName
      userComment
      restaurantComment
      userPostDate
      memberHash
      mealPeriod
      planName
      rating {
        totalValue
        food
        service
        atmosphere
        costPerformance
      }
      useScene
    }
    ... on LyReview {
      handleName
      userComment
      restaurantComment
      userPostDate
      totalValue : rating
    }
  }
`)
